import { deepClone } from '~theme/utils/deepClone';

type WatchableRecordKey = string;
type WatchableRecord = Record<WatchableRecordKey, any>;
export type WatchRecordCallback<T> = (
  value: T,
  oldValue: T,
  effectedKeys: (keyof T)[]
) => any;
/*
 * Recordの変更を監視して、変更されたキーを取得できるwatch。
 * 1階層目のプロパティしか変更されたキー一覧として取得できないので、もっと深く監視したい場合はがんばって。
 */
export const watchRecord = <T extends WatchableRecord>(
  target: RefOrGetterFunction<T>,
  cb: WatchRecordCallback<T>
) => {
  let oldValue = deepClone(toValue(target));

  watch(
    target,
    (newValue) => {
      cb(newValue, oldValue, getChangedKeys(newValue, oldValue));
      oldValue = deepClone(newValue);
    },
    {
      deep: true,
    }
  );
};

const getChangedKeys = <T extends WatchableRecord>(
  newValue: T,
  oldValue: T
): (keyof T)[] => {
  const newKeys = Object.keys(newValue);
  const oldKeys = Object.keys(oldValue);
  const mergedKeys = Array.from(new Set([...newKeys, ...oldKeys]));
  return mergedKeys.filter(
    (key) => newValue[key] !== oldValue[key]
  ) as unknown as (keyof T)[];
};
